<div class="modal-body content width-700 ">
	<div class="layout-auto-1-auto">
    <span class="modal-header">
      {{getRessource('Header')}}
    </span>
		<div class="content grid cols-6 ">
			<app-exg-select-enumeration #VCrcptTyp
											            [(value)]="dataModelClone.adr_enmIdent_AdresseTyp"
											            [caption]="enumSvc.getFieldCaption('Adresse', 'AdresseTyp')"
											            enumerationName="AdresseTyp"
			                            name="type"
																	class="span-6">
			</app-exg-select-enumeration>

			<exg-input [(ngModel)]="dataModelClone.adrStr"
								 [caption]="enumSvc.getFieldCaption('Adresse', 'adrStr')"
			           class="span-5">
			</exg-input>
			<exg-input [(ngModel)]="dataModelClone.adrHNum"
			           [caption]="enumSvc.getFieldCaption('Adresse', 'adrHNum')"
			           class="">
			</exg-input>

			<exg-input [(ngModel)]="dataModelClone.adrZusatz"
								 [caption]="enumSvc.getFieldCaption('Adresse', 'adrZusatz')"
			           class="span-6">
			</exg-input>

			<exg-input [(ngModel)]="dataModelClone.adrLkz"
								 [caption]="enumSvc.getFieldCaption('Adresse', 'adrLkz')"
			           class="">
			</exg-input>
			<exg-input [(ngModel)]="dataModelClone.adrPlz"
								 [caption]="enumSvc.getFieldCaption('Adresse', 'adrPlz')"
			           class="span-2">
			</exg-input>
			<exg-input [(ngModel)]="dataModelClone.adrOrt"
								 [caption]="enumSvc.getFieldCaption('Adresse', 'adrOrt')"
								 class="span-3">
			</exg-input>

			<exg-textarea [(ngModel)]="dataModelClone.adrBez"
			              [caption]="enumSvc.getFieldCaption('Adresse', 'adrBez')"
			              class="span-6">
			</exg-textarea>
		</div>
		<div class="spawn-modal-actions typo-small">
			<button (click)="delete()" class="md-btn"
			        *ngIf="dataModel?.adrID">
				{{getGlobal('Delete')}}
			</button>
			<button (click)="cancel()" class="md-btn">
				{{getGlobal('Cancel')}}
			</button>
			<button (click)="save()"
			        [class.disabled]="!appSvc.helperObj.changed(dataModel, dataModelClone)"
			        class="md-btn">
				{{getGlobal('Create')}}
			</button>
		</div>
	</div>
</div>
